import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseDataService} from '../commons/base-data.service';
import {Observable} from 'rxjs/Observable';
import {HelpersService} from '../../core/helpers/helpers.service';

@Injectable()
export class StaticDataService extends BaseDataService {

  constructor(private http: HttpClient,
              helpers: HelpersService) {
    super(helpers);
  }

  getStaticContent(id: string): Observable<string> {
    // TODO add caching
    return this.http.get('assets/static/' + id + '.html', {responseType: 'text'}).map((html: any) => html.toString());
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/static/static-data.service.ts